const reportsWithoutPeriod = [
    'outstanding-courses',
    'outstanding-acc-balances',
    'outstanding-gift-vouchers',
    'top-spender'
];
export default reportsWithoutPeriod;
